import { useEffect, useState } from "react";
import cx from "classnames";
import { trackEvent } from "@/lib/analytics";
import { useLenis } from "@/lib/LenisProvider";
import { Button } from "@/components/Button/Button";
import { chrome } from "@/spiel/chrome";
import styles from "./Nav.module.scss";

export const Nav = () => {
  const { scrollTo } = useLenis();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href: string, label?: string) => {
    trackEvent("nav_click", {
      link_href: href,
      link_label: label ?? href,
    });
    scrollTo(href);
  };

  return (
    <header
      className={cx(styles.nav, {
        [styles.scrolled]: scrolled,
      })}
    >
      <div className={styles.inner}>
        <button
          type="button"
          className={styles.logo}
          onClick={() => handleNav("#hero", chrome.brandName)}
          aria-label={chrome.homeAriaLabel}
        >
          <img
            src="/devarmlogo.svg"
            alt={chrome.brandName}
            width={119}
            height={40}
          />
        </button>

        <nav className={styles.links} aria-label="Primary">
          {chrome.navLinks.map((link) => (
            <button
              key={link.href}
              type="button"
              className={styles.link}
              onClick={() => handleNav(link.href, link.label)}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <Button
          variant="primary"
          className={styles.cta}
          onClick={() => handleNav("#contact", chrome.ctaPrimary)}
        >
          {chrome.ctaPrimary}
        </Button>
      </div>
    </header>
  );
};
